import { makeStyles } from "@mui/styles";
import { appColors, backgroundColors } from "src/consts/app-config";
import theme from "src/theme";

export const useStyles = makeStyles({
    wrapper: {
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        cursor: "pointer",
        opacity: 0.7,
        transition: "0.3s ease",
        "&.active": {
            opacity: 1,
        },
        "&:hover": {
            opacity: 1,
        },
        "&:hover .iconShadow": {
            opacity: 1,
        },
        "&:hover .icon": {
            transform: "scale(1.08) translateY(-10px)",
        },
    },
    imageBox: {
        width: 60,
        height: 60,
        position: "relative",
        [theme.breakpoints.up(1800)]: {
            width: 84,
            height: 84,
        },
    },
    icon: {
        transition: "0.3s ease",
        width: "100%",
        height: "100%",
        objectFit: "contain",
        zIndex: 3,
        position: "relative",
    },
    iconShadow: {
        position: "absolute",
        bottom: 0,
        left: "50%",
        transform: "translateX(-50%)",
        opacity: 0,
        transition: "0.3s ease",
        "&.active": {
            opacity: 1,
        },
    },
    label: {
        color: appColors.white,
        textDecoration: "none",
        fontFamily: "Montserrat",
        fontSize: "16px",
        fontWeight: 400,
        letterSpacing: "0.02em",
    },
    unavailable: {
        opacity: '0.3',
        cursor: 'default', 
        "&:hover": {
            opacity: '0.3',
        },
        "&:hover .iconShadow": {
            opacity: '0.3',
        },
        "&:hover .icon": {
            transform: "scale(1.08) translateY(-10px)",
        },
    },
});
